export default __webpack_public_path__ + "static/media/CNo.42-1.f4e7fef8.jpg";